import { render, staticRenderFns } from "./saleRecordSee.vue?vue&type=template&id=3caecca6&scoped=true&"
import script from "./saleRecordSee.vue?vue&type=script&lang=js&"
export * from "./saleRecordSee.vue?vue&type=script&lang=js&"
import style0 from "./saleRecordSee.vue?vue&type=style&index=0&id=3caecca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caecca6",
  null
  
)

export default component.exports